import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import WhatsAppFab from './components/layout/WhatsAppFab';
import SmoothScroll from './components/layout/SmoothScroll';
import Home from './pages/Home/Home';
import Programs from './pages/Programs/Programs';
import Shop from './pages/Shop/Shop';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import LoveCode from './pages/LoveCode/LoveCode';
import BusinessCode from './pages/BusinessCode/BusinessCode';
import LoveShift from './pages/LoveShift/LoveShift';
import LoveCodeDE from './pages/LoveCodeDE/LoveCodeDE';
import MasterclassFunnel from './pages/MasterclassFunnel/MasterclassFunnel';
import BeziehungsheilungDE from './pages/BeziehungsheilungDE/BeziehungsheilungDE';
import Impressum from './pages/Legal/Impressum';
import Datenschutz from './pages/Legal/Datenschutz';
import AGB from './pages/Legal/AGB';

const STANDALONE_ROUTES = [
  '/love-shift-masterclass',
  '/seelenpartner-love-code',
  '/masterclass',
  '/beziehungsheilung-fuer-frauen',
];

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  const location = useLocation();
  const isStandalone = STANDALONE_ROUTES.includes(location.pathname);

  return (
    <SmoothScroll>
      <div className="min-h-screen flex flex-col font-sans bg-dark text-cream selection:bg-gold selection:text-dark">
        <ScrollToTop />
        {!isStandalone && <Navbar />}
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programme" element={<Programs />} />
            <Route path="/beziehungsheilung-fuer-frauen" element={<BeziehungsheilungDE />} />
            <Route path="/female-leadership-fuer-frauen" element={<BusinessCode />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/love-shift-masterclass" element={<LoveShift />} />
            <Route path="/seelenpartner-love-code" element={<LoveCodeDE />} />
            <Route path="/masterclass" element={<MasterclassFunnel />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
        </div>
        {!isStandalone && <Footer />}
        <WhatsAppFab />
      </div>
    </SmoothScroll>
  );
}

export default App;